import React from 'react';
import { Input } from 'antd';
import SearchDeviceComponent from '../../components/SearchDevice';
import IconSearch from '../../assets/icons/search.svg';
import { useTranslation } from 'react-i18next';

const PinnedCameraComponent = ({
  pinCamera,
  checkGroup,
  addCameraGroup,
}) => {
  const { t } = useTranslation();

  return (
    <div className="pinned-camera-component">
      {checkGroup === 0 ? (
        <div className="search-camera">
          <SearchDeviceComponent deviceType="camera" callback={pinCamera}>
            <Input
              prefix={
                <img
                  src={IconSearch}
                  alt="camera on"
                  className="camera-search-icon"
                />
              }
              className="search-camera-input"
              placeholder={t('Select camera to pin')}
              style={{ textAlign: 'center' }}
            />
          </SearchDeviceComponent>
        </div>
      ) : (
        <div className="search-camera">
          <SearchDeviceComponent deviceType="camera" callback={addCameraGroup}>
            <Input
              prefix={
                <img
                  src={IconSearch}
                  alt="camera on"
                  className="camera-search-icon"
                />
              }
              className="search-camera-input"
              placeholder={t('Add camera to group')}
              style={{ textAlign: 'center' }}
            />
          </SearchDeviceComponent>
        </div>
      )}
    </div>
  );
};

export default PinnedCameraComponent;
